module.exports = __webpack_public_path__ + "img/get-free-insurance-quote-page-bottom.c7d58f19.svg";